








































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class StatementBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly sum!: number;

  @Prop() readonly currencyRate!: any;

  @Prop() readonly toggleMode!: boolean;

  utilsInstance = utils;

  nowCurrency = '';

  calRate(value: number, rate: string) {
    this.nowCurrency = rate;
    return (value / this.currencyRate[rate]);
  }

  calFooter(value: number) {
    return (value / this.currencyRate[this.nowCurrency]);
  }
}
